import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { ONE_HOUR } from "../constants";

export const useListEvents = () => {
  const listEvents = () =>
    reactQueryGet(internalApi.supportWidget.listEvents());

  return useQuery(["events"], () => listEvents(), {
    staleTime: ONE_HOUR,
    retry: false,
  });
};
